import React from 'react';
import { useState } from 'react';
import Div from '../Div';
const accordionData = [
  {
    question: 'What types of engineering design services do you offer?',
    answer:
      'We specialize in 3D CAD modeling, prototyping, and design optimization. Our design process emphasizes functionality, manufacturability, and innovation to ensure your product performs well in real-world applications.',
  },
  {
    question: 'How do simulations benefit my product development?',
    answer:
      "Simulations reduce development time and cost by predicting how a product will behave before it's built. They allow you to make informed design decisions and avoid costly revisions.",
  },
  {
    question: 'What kind of custom engineering solutions do you provide?',
    answer:
      "We offer tailored solutions for unique industrial challenges—whether it's streamlining a production process, automating systems, or developing entirely new mechanisms. Each solution is built to meet your specific goals.",
  },
  {
    question: 'How do I get started with your services?',
    answer:
      "You can get started by contacting us through our website or email. We'll schedule a consultation to understand your project needs and propose a tailored solution.",
  },
  {
    question: 'Do you offer support throughout the project development cycle?',
    answer:
      "Yes. From initial concept to final prototype or system deployment, we provide ongoing support and iterative feedback to ensure your goals are met at every stage.",
  },
];

export default function Accordion() {
  const [selected, setSelected] = useState(0);
  const handelToggle = index => {
    if (selected === index) {
      return setSelected(null);
    }
    setSelected(index);
  };

  return (
    <Div className="cs-accordians cs-style1">
      {accordionData.map((item, index) => (
        <Div
          className={`cs-accordian ${selected === index ? 'active' : ''}`}
          key={index}
        >
          <Div
            className="cs-accordian_head"
            onClick={() => handelToggle(index)}
          >
            <h2 className="cs-accordian_title">{item.question}</h2>
            <span className="cs-accordian_toggle cs-accent_color">
              <svg
                width={15}
                height={8}
                viewBox="0 0 15 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0L7.5 7.5L15 0H0Z" fill="currentColor" />
              </svg>
            </span>
          </Div>
          <Div className="cs-accordian_body">
            <Div className="cs-accordian_body_in">{item.answer}</Div>
          </Div>
        </Div>
      ))}
    </Div>
  );
}
